module.exports = __webpack_public_path__ + "static/img/3.e194092.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/3.png
// module id = lYal
// module chunks = 0